import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { Elements, useStripe, CardElement } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Header from './Header';
import './SharedStyleSheet.css';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';


const stripePromise = loadStripe('pk_test_N0I3Hv6igmpqyZlYNirvaazC');

const products = [
  { id: '10min', name: '10-minute card', price: 5, features: ['.50 $/min', 'Saved Sessions', 'Try Us'] },
  { id: '30min', name: '30-minute card', price: 10, features: ['.35 $/min', 'Saved Sessions', 'Most Popular'] },
  { id: '120min', name: '120-minute card', price: 30, features: ['.25 $/min', 'Saved Sessions', 'Best Value'] },
];

function isCallGeeptDomain() {
  return window.location.hostname === 'callgeept.ai';
}
const isWaitingList = isCallGeeptDomain();

function SignUp() {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const [product, setProduct] = useState('');
  const [cardError, setCardError] = useState(null);
  const stripe = useStripe();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe) {
      return;
    }

    const result = await stripe.createToken();

    if (result.error) {
      setCardError(result.error.message);
    } else {
      // TODO: Send the token to your server to create a charge
    }
  };

  const handleProductSelect = (productId) => {
    setProduct(productId);
  };

  const isSignUpDisabled = !product;


  const signUpForm = (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="formBasicEmail">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email" placeholder="Enter email" />
        <Form.Text className="text-muted">
          We'll never share your email with anyone else.
        </Form.Text>
      </Form.Group>
      <Form.Group controlId="formBasicPassword">
        <Form.Label>Password</Form.Label>
        <Form.Control type="password" placeholder="Password" />
      </Form.Group>

      <Form.Group controlId="formConfirmPassword">
        <Form.Label>Confirm Password</Form.Label>
        <Form.Control type="password" placeholder="Confirm Password" />
      </Form.Group>

      {product && (
        <div className="form-card">
          <Form.Group controlId="formCardElement">
            <Form.Label className="form-label">Card information</Form.Label>
            <CardElement className="StripeElement" />
            {cardError && <div className="text-danger">{cardError}</div>}
          </Form.Group>
        </div>
      )}

      <Button
        variant="primary"
        type="submit"
        className="w-100 mt-4"
        disabled={isSignUpDisabled}
      >
        Sign Up
      </Button>
    </Form>
  );

  return (
    <div className="signup-page">
      <Container>
        <Row>
          <Col xs={12} md={{ span: 8, offset: 2 }}>
            <div className="signup-form-container">
              <h1 className="text-center">Sign Up</h1>
              <Row>
                <Col md={6} className="product-selection">
                  <h3 className="text-center mb-4">Select a product</h3>
                  <Form.Group controlId="formProductSelect">
                    <Form.Label>Select a product</Form.Label>
                    {products.map((p) => (
                      <Form.Check
                        key={p.id}
                        type="radio"
                        label={`${p.name} ($${p.price})`}
                        name="productSelect"
                        id={`productSelect - ${p.id}`}
                        checked={product === p.id}
                        onChange={() => handleProductSelect(p.id)} />
                    ))}
                  </Form.Group>
                  <div className="pricing-table">
                    {products.map((p) => (
                      <div
                        key={p.id}
                        className={`pricing - plan ${product === p.id ? 'selected' : ''}`}
                        onClick={() => handleProductSelect(p.id)}
                      >
                        <div className="plan-header">
                          <h4>{p.name}</h4>
                        </div>
                        <div className="plan-price">
                          <span className="plan-currency">$</span>
                          <span className="plan-value">{p.price}</span>
                        </div>
                        <div className="plan-features">
                          {p.features.map((feature) => (
                            <div key={feature} className="plan-feature">
                              <FontAwesomeIcon icon={faCheck} className={`mr - 2 ${product === p.id ? 'text-primary' : ''}`} />
                              {feature}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
                <Col md={6}>
                  {isWaitingList ? (
                    <iframe
                      src="https://cdn.forms-content.sg-form.com/3430c76c-d9a8-11ed-a398-5e90fb7f85ca"
                      style={{ width: '100%', height: '600px', border: 'none' }}
                      title="SendGrid Signup Form"
                    />
                  ) : signUpForm}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div >
  );
}

function SignUpWithStripe() {
  return (
    <div className="signup-page" style={{ marginTop: '20px' }}> 
      {isWaitingList ? (
        <iframe
          src="https://cdn.forms-content.sg-form.com/3430c76c-d9a8-11ed-a398-5e90fb7f85ca"
          style={{ width: '100%', height: '800px', border: 'none' }}
          title="SendGrid Signup Form"
        />
      ) : (
        <Elements stripe={stripePromise}>
          <SignUp />
        </Elements>
      )}
    </div>
  );
}



export default SignUpWithStripe;
